import qs from 'qs';

interface Input {
  routingNumber?: string;
  transitNumber?: string;
  institutionNumber?: string;
  countryCode?: string;
}

export interface Success {
  city: string;
  name: string;
  routing_number: string;
  state: string; // US State or Canadian Province
}

export type Result = Success | {};

const BANK_ROUTING_NUMBERS_HOST = 'https://routing-number-lookup.reverb.com/routing_number';

export async function verifyBankRoutingNumber(input: Input): Promise<Result> {
  try {
    return await (await fetch(`${BANK_ROUTING_NUMBERS_HOST}?${inputToParams(input)}`)).json();
  } catch (error) {
    return {};
  }
}

function inputToParams(input: Input) {
  return qs.stringify({
    routing_number: input.routingNumber,
    transit_number: input.transitNumber,
    institution_number: input.institutionNumber,
    country_code: input.countryCode,
  });
}
